import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { forkJoin, Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { isNullOrUndefined, ToastService } from "src/app/core";
import {
  AdditionalInfoObject,
  ConfigurationApi,
  ExitRequestActivity,
  IImmigrationDocumentVisaMappingDTO,
  ImmAdditionalInfo,
  ImmigrationApi,
  ImmigrationDocumentVisaMappingDTO,
  LookupApi,
  LookupField,
} from "src/app/core/api.gen";
import { CommonService } from "src/app/core/common.service";
import { LoaderService } from "src/app/core/loader.service";
import { LookupTypeKeys } from "src/app/shared/lookup-type-keys";
import { nullSafe } from "src/app/utils";

@Component({
  selector: "eos-imm-document-visamapping-edit",
  templateUrl: "./imm-document-visamapping-edit.component.html",
  styleUrls: ["./imm-document-visamapping-edit.component.css"],
})
export class ImmDocumentVisamappingEditComponent implements OnInit {
  activity: ImmigrationDocumentVisaMappingDTO;
  countries: LookupField[];
  visaTypes: LookupField[];
  documentTypes: LookupField[];
  documentNames: LookupField[];
  isEdit: boolean;
  @Input() public countryId: number;
  @Input() public visaTypeId: number;
  get isEditMode(): boolean {
    return this.activity !== undefined && this.isEdit;
  }

  activityTypes = [
    {
      id: 100,
      displayText: "Email",
      disabled: false,
    },
    {
      id: 101,
      displayText: "Profile update",
    },
    {
      id: 102,
      displayText: "External",
      disabled: false,
    },
    {
      id: 103,
      displayText: "Request",
      disabled: false,
    },
  ];

  createForm = new UntypedFormGroup({
    // newlyadded
    country: new UntypedFormControl(null, Validators.required),
    visaType: new UntypedFormControl(null, Validators.required),
    documentType: new UntypedFormControl(null, Validators.required),
    documentName: new UntypedFormControl(null, Validators.required),
    isApprover: new UntypedFormControl(false, [Validators.required]),
    isRequestor: new UntypedFormControl(false, [Validators.required]),
    instruction: new UntypedFormControl(null, Validators.required),
    mandatory: new UntypedFormControl(false),
    cm9Filing: new UntypedFormControl(false),
    id: new UntypedFormControl(0),
    inactive: new UntypedFormControl(false, null),

    officeToBeVisited: new UntypedFormControl(null),
    nationalityType: new UntypedFormControl(null),
    ranks: new UntypedFormControl(null),
    nationality: new UntypedFormControl(null),
    excludedNationality: new UntypedFormControl(null),
    currentVisaStatus: new UntypedFormControl(null),
    officeLE: new UntypedFormControl(null),
    gender: new UntypedFormControl(),
    shortTermVisa: new UntypedFormControl(null),
    typeOfSupport: new UntypedFormControl(null),
    employeeCurrentLocation: new UntypedFormControl(null),
    immigrationCaseType: new UntypedFormControl(null),
    // newlyadded
  });
  activityId: number;
  exitSubTypeInfo = [];
  visaTypesInfo = [];
  documentNamesInfo = [];

  immigrationCaseType: LookupField[] = [];
  officeToBeVisited: LookupField[] = [];
  employeeCurrentLocation: LookupField[] = [];
  typeOfSupport: LookupField[];
  shortTermVisa: LookupField[];
  rank: LookupField[] = [];
  gender: LookupField[];
  officeLE: LookupField[] = [];
  currentVisaStatus: LookupField[];
  nationality: LookupField[];
  nationalityType: LookupField[] = [];
  fieldAccessibility = [];
  immigrationCaseTypeOrg: LookupField[] = [];
  hideICT: boolean = false;
  constructor(
    private configurationService: ConfigurationApi,
    private loader: LoaderService,
    public modal: NgbActiveModal,
    private toast: ToastService,
    private common: CommonService,
    private lookupApi: LookupApi,
    private immigrationApi: ImmigrationApi
  ) { }

  ngOnInit() {
    if (this.countryId != 0) {
      this.createForm.controls.country.setValue(this.countryId);
      this.countryValueChange();
      this.loadData();
      if (this.visaTypeId != 0)
        this.createForm.controls.visaType.setValue(this.visaTypeId);
    }

    this.loadSupportingData().subscribe((p) => {
      this.gender = p.gender;
      this.immigrationCaseType = p.immigrationCaseType;
      this.currentVisaStatus = p.currentVisaStatus;
      this.nationality = p.nationality;
      this.shortTermVisa = p.shortTermVisa;
      this.typeOfSupport = p.typeOfSupport;
      this.employeeCurrentLocation = p.employeeCurrentLocation;
      this.rank = p.rank;
      this.nationalityType = p.nationalityType;
      this.immigrationCaseTypeOrg = p.immigrationCaseType;
      if (this.visaTypeId != 0){
        this.onVisaTypeChange(this.visaTypeId);
      }
      if(this.isEditMode){
        var visType = this.visaTypes.find((x) => x.value == this.activity.visaTypeValue);
        this.onVisaTypeChange(visType.id);
      }
    });

    if (this.isEditMode) {
      this.bindActivityInfo(this.activity);
    }
  }

  loadSupportingData() {
    return forkJoin({
      officeToBeVisited: this.common.prepareLookupObservable(
        LookupTypeKeys.OFFICE_LOCATION
      ),
      nationalityType: this.common.prepareLookupObservable(
        LookupTypeKeys.NATIONALITY_TYPE
      ),
      rank: this.common.getAllGlobalRanks(),
      nationality: this.common.prepareLookupObservable(
        LookupTypeKeys.NATIONALITY
      ),
      currentVisaStatus: this.common.prepareLookupObservable(
        LookupTypeKeys.CURRENT_VISA_STATUS
      ),
      officeLE: this.common.prepareLookupObservable(
        LookupTypeKeys.OFFICE_LOCATION
      ),
      gender: this.common.prepareLookupObservable(LookupTypeKeys.GENDER, 0, 0),
      shortTermVisa: this.common.prepareLookupObservable(
        LookupTypeKeys.SHORT_TERM_VISA
      ),
      typeOfSupport: this.common.prepareLookupObservable(
        LookupTypeKeys.TYPE_OF_SUPPORT
      ),
      employeeCurrentLocation: this.common.GetOfficeLocationsAllCountries(),
      immigrationCaseType: this.common.prepareLookupObservable(
        LookupTypeKeys.IMMIGRATION_CASE_TYPE,
        0,
        0
      ),
    });
  }

  createActivity() {
    const rawValues = this.createForm.getRawValue();
    const immMappings = this.getFormData(rawValues);
    this.loader.show();
    this.configurationService
      .saveImmDocumentVisaMappings(immMappings)
      .pipe(finalize(() => this.loader.clear()))
      .subscribe(
        (resp) => {
          if (resp.statusCode == 400) {
            this.toast.warning("Activity with same order already exist");
          } else {
            if (this.isEditMode) {
              this.toast.success("Successfully updated activity");
            } else {
              this.toast.success("Successfully created activity");
            }
            this.modal.close("success");
          }
        },
        (err) => this.toast.error("Error occured please try again!")
      );
  }

  bindActivityInfo(r: ImmigrationDocumentVisaMappingDTO) {
    var visType = this.visaTypes.find((x) => x.value == r.visaTypeValue);
    var docName = this.documentNames.find((x) => x.id == r.documentNameId);
    this.createForm.patchValue({
      country: visType.parentFieldId,
     documentType: docName.parentFieldId,
    });
    this.countryValueChange();
    this.documentTypeValueChange();
    this.createForm.patchValue({
      country: visType.parentFieldId,
      isRequestor: r.isRequestor,
      isApprover: r.isApprover,
      instruction: r.instruction,
      visaType: visType.id,
      documentName: docName.id,
      documentType: docName.parentFieldId,
      id: r.id,
    });
    if (r.additionalInfo) {
      this.createForm.patchValue({
        cm9Filing: r.additionalInfo.cm9Filing,
        mandatory: r.additionalInfo.mandatory,

        officeToBeVisited: r.additionalInfo.officeLocation,
        nationalityType: r.additionalInfo.nationalityType,
        ranks: r.additionalInfo.rank,
        nationality: r.additionalInfo.nationality,
        excludedNationality: r.additionalInfo.excludedNationality,
        currentVisaStatus: r.additionalInfo.currentVisaStatusId,
        officeLE: r.additionalInfo.officeLE,
        gender: r.additionalInfo.gender,
        shortTermVisa: r.additionalInfo.shortTermVisa,
        typeOfSupport: r.additionalInfo.typeOfSupport,
        employeeCurrentLocation: r.additionalInfo.empCurrentLocation,
        immigrationCaseType: r.additionalInfo.immigrationCaseTypeId,
      });
    }
    this.loadData();
  }

  getFormData(rawValues) {
    var docId = rawValues.documentName;
    var visaId = rawValues.visaType;

    var docName = this.documentNamesInfo.find((x) => x.id == docId);
    var visa = this.visaTypesInfo.find((x) => x.id == visaId);

    const internalAct = new ImmigrationDocumentVisaMappingDTO({
      visaTypeValue: visa.value,
      documentValue: docName.value,
      documentNameId: docId,
      instruction: rawValues.instruction,
      isApprover: rawValues.isApprover,
      isRequestor: rawValues.isRequestor,
      id: rawValues.id,
      additionalInfo: this.checkIfAdditionalInfoNull(rawValues),
    });
    return internalAct;
  }

  onChkChange($event) {
    switch ($event.target.id) {
      case "isRequestor":
        this.createForm.patchValue({
          isRequestor: $event.target.checked,
          isApprover: false,
          inactive: false,
        });
        break;
      case "isApprover":
        this.createForm.patchValue({
          isRequestor: false,
          isApprover: $event.target.checked,
          inactive: false,
        });
        break;
      case "inactive":
        this.createForm.patchValue({
          isRequestor: false,
          isApprover: false,
          inactive: $event.target.checked,
        });
        break;
    }
  }
  onCountryChange($event) {
    this.countryValueChange();
    this.createForm.controls.visaType.reset();
    this.loadData();
  }
  onDocumentTypeChange($event) {
    this.createForm.controls.documentName.reset();
    this.documentTypeValueChange();
  }

  loadData() {
    const countryId = this.createForm.controls.country.value;
    const country = this.countries.find((x) => x.id === countryId);
    if (country) {
      this.lookupApi
        .getOfficeLEByCountryCode(country.value)
        .subscribe((resp) => {
          this.officeLE = resp.filter(x=>x.isActive==true);
        });
      this.lookupApi.getOfficeLocations(country.value).subscribe((resp) => {
        this.officeToBeVisited = resp;
      });
    }
  }

  countryValueChange() {
    const a = this.createForm.controls.country.value;
    if (a != null && a !== undefined) {
      this.visaTypesInfo = this.visaTypes.filter((i) =>
        [a].includes(i.parentFieldId)
      );
      let location = this.countries.find(x => x.id == a).displayText.replace(/\s+/g, '');
      location = location.charAt(0).toLowerCase() + location.slice(1);
      this.immigrationApi.getLocationFieldAccessibility('IMM').subscribe((resp) => {
        this.fieldAccessibility = resp.map(item => ({fieldName: item.fieldName, location: item[location]}));
      });
    }
  }

  documentTypeValueChange() {
    const a = this.createForm.controls.documentType.value;
    if (a != null && a !== undefined) {
      this.documentNamesInfo = this.documentNames.filter((i) =>
        [a].includes(i.parentFieldId)
      );
    }
  }

  exitTypeValueChange() {
    const a = this.createForm.controls.exitType.value;
    // if (a != null && a !== undefined) {
    //   this.exitSubTypeInfo = this.exitSubTypes.filter((i) =>
    //     [a].includes(i.parentFieldId)
    //   );
    // }
  }

  resetValue() {
    this.createForm.get("exitSubType").reset();
  }

  onCancel() {
    this.modal.dismiss();
  }

  checkIfAdditionalInfoNull(rawValues) {    
    const obj = new ImmAdditionalInfo({
      mandatory: rawValues.mandatory,
      cm9Filing: rawValues.cm9Filing,
      officeLocation: rawValues.officeToBeVisited,
      nationalityType: rawValues.nationalityType,
      rank: rawValues.ranks,
      nationality: rawValues.nationality,
      excludedNationality: rawValues.excludedNationality,
      currentVisaStatusId: rawValues.currentVisaStatus,
      officeLE: rawValues.officeLE,
      gender: rawValues.gender,
      shortTermVisa: rawValues.shortTermVisa,
      typeOfSupport: rawValues.typeOfSupport,
      empCurrentLocation: rawValues.employeeCurrentLocation,
      immigrationCaseTypeId: rawValues.immigrationCaseType,
    });
    Object.keys(obj).forEach((key) => {
      if (
        obj[key] === null ||
        obj[key] === undefined ||
        nullSafe(() => obj[key].length === 0)
      ) {
        delete obj[key];
      }
    });
    return !this.removeEmpty(obj) ? obj : null;
  }

  removeEmpty(additionalInfo) {
    return Object.values(additionalInfo).every((x) => x === null);
  }
  isFieldEnabled(fieldName: string): boolean {
    if(this.IsMiscellaneous()){
       return false;
    }
    else if(isNullOrUndefined(this.fieldAccessibility) || this.fieldAccessibility.length == 0 )
      return true;
    else {
      const field = this.fieldAccessibility.find(f => f.fieldName === fieldName);
      return field ? field.location : false;
    }
  }
  onVisaTypeChange(selectedVisaTypeId: number){
    this.hideICT = false;
    this.immigrationCaseType = this.immigrationCaseTypeOrg;
    this.lookupApi.getMappedLookUpFieldValues(LookupTypeKeys.IMMIGRATION_CASE_TYPE, selectedVisaTypeId).subscribe(data => {
      if(data?.length > 0)
      this.immigrationCaseType = this.immigrationCaseType.filter(x=> data.includes(x.id));
      else
      this.hideICT = true;
    });
  }
  IsMiscellaneous(){
    var documentNameId = this.createForm.controls.documentName.value
    let miscellaneousId = [12399, 12766, 15011, 6083]
    if (miscellaneousId.includes(documentNameId)){
      return true;
    }
    return false;
  }
}
